import type { Access } from '@thinkalpha/access-ws-client/contracts/user.js';

/**
 * Returns true when the user's access model is subscription-based.
 * A user is a subscription user when they have no firm or firm-membership access — i.e.
 * they are expected to subscribe to a paid plan rather than being covered by an institution.
 *
 * Use this function (rather than re-implementing the check) wherever subscription eligibility
 * needs to be determined.
 */
export function isSubscriptionUser(accessList: ReadonlyArray<Access>): boolean {
    return !accessList.some((a) => a.type === 'firm' || a.type === 'firm-membership');
}
